function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.22153 3.22183C7.5173 -1.07394 14.4821 -1.07394 18.7779 3.22183C23.0736 7.51759 23.0736 14.4824 18.7779 18.7782C14.4821 23.0739 7.5173 23.0739 3.22153 18.7782C-1.07423 14.4824 -1.07423 7.51759 3.22153 3.22183ZM4.63575 4.63604C1.12103 8.15076 1.12103 13.8492 4.63575 17.364C8.15047 20.8787 13.849 20.8787 17.3637 17.364C20.8784 13.8492 20.8784 8.15076 17.3637 4.63604C13.849 1.12132 8.15047 1.12132 4.63575 4.63604ZM9.75707 12L6.75707 12C6.20478 12 5.75707 11.5523 5.75707 11C5.75707 10.4477 6.20478 10 6.75707 10L9.75707 10V7C9.75707 6.44772 10.2048 6 10.7571 6C11.3094 6 11.7571 6.44772 11.7571 7V10L14.7571 10C15.3094 10 15.7571 10.4477 15.7571 11C15.7571 11.5523 15.3094 12 14.7571 12L11.7571 12V15C11.7571 15.5523 11.3094 16 10.7571 16C10.2048 16 9.75707 15.5523 9.75707 15V12Z",
  className: "svg-fill"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.67a7bb2b.svg";
export { ForwardRef as ReactComponent };